//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'OnboardingSurveyPage',

  beforeRouteEnter(to, _, next) {
    const { step } = to.query

    if (step) {
      return next((vm) => {
        vm.doStep(vm.floorId ? step : 'start')
      })
    }

    next()
  },

  beforeRouteUpdate(to, _, next) {
    next()

    const step = to.query?.step || 'start'

    if (step && step !== this.step) {
      this.doStep(step)
    }

    if (this.$store.state.surveyCompletedSection) {
      this.$store.commit('updateSurveyCompletedSection', '')
    }
  },

  layout: 'page',

  data() {
    return {
      pageLoading: false,
      step: 'start',
      formLoading: false,
      sections: [],
    }
  },

  computed: {
    surveyInfo() {
      return this.$store.state.surveyInfo || {}
    },
    floors() {
      return (
        this.$store.state.surveyFloors.filter(
          (floor) => floor.status !== 'answered'
        ) || []
      )
    },
    completedfloors() {
      return this.$store.state.surveyFloors.filter(
        (floor) => floor.status === 'answered'
      )
    },
    floorId() {
      return this.$store.state.surveyFloorId
    },
    floor() {
      return this.floors.find((floor) => floor.id === this.floorId) || {}
    },
    completedfloorsText() {
      return this.completedfloors.map((floor) => floor.name).join('、')
    },
    pageTitle() {
      switch (this.step) {
        case 'sections':
          return `${this.floor.name}のサービス設定`
        default:
          return ''
      }
    },
    completedTips() {
      if (this.$store.state.surveyCompletedSection) {
        const section = this.$store.state.surveySections.find(
          (section) => section.id === this.$store.state.surveyCompletedSection
        )

        if (section) {
          return `${section.title}が完了しました。`
        }
      }

      return ''
    },
    allCompleted() {
      return (
        this.completedfloors.length === this.$store.state.surveyFloors.length
      )
    },
    sectionsGuideLink() {
      const sectionsIds = this.sections.map((item) => item.id)

      if (
        sectionsIds.includes('YasaiDeliverySetting') &&
        sectionsIds.includes('GohanDeliverySetting')
      ) {
        return 'https://www.officedeyasai.jp/wp-content/themes/ody/download/startguide/both/officedeyasai_step1.pdf'
      }

      if (sectionsIds.includes('YasaiDeliverySetting')) {
        return 'https://www.officedeyasai.jp/wp-content/themes/ody/download/startguide/yasai/yasai_step1.pdf'
      }

      if (sectionsIds.includes('GohanDeliverySetting')) {
        return 'https://www.officedeyasai.jp/wp-content/themes/ody/download/startguide/gohan/gohan_step1.pdf'
      }

      return ''
    },
  },

  async mounted() {
    if (this.step === 'start') {
      await this.init()
    }
  },

  methods: {
    async init() {
      this.pageLoading = true

      const res = await this.$axios.$get('/onboarding-survey/start')

      this.pageLoading = false

      this.$store.commit('updateSurveyInfo', res.data)
    },
    async fetchFloors() {
      this.pageLoading = true

      const floors = await this.$store.dispatch('fetchSurveyFloors')

      this.pageLoading = false

      return floors
    },
    async fetchSurveySections() {
      this.pageLoading = true

      const res = await this.$axios.$get('/onboarding-survey/sections', {
        params: {
          floorId: this.floorId,
        },
      })

      this.pageLoading = false

      const { sections } = res.data

      this.sections = sections

      this.$store.commit('updateSurveySectons', sections)

      if (sections.every((item) => item.status === 'answered')) {
        // need to reset floorId when all sections are answered
        this.$store.commit('updateSurveyFloorId', null)

        this.doStep('floors')
      }
    },
    doSection(section) {
      if (section.status === 'answered' || section.status === 'pending') {
        return
      }

      this.$router.push({
        path: '/onboarding-survey/section',
        query: {
          sectionId: section.id,
          floorId: this.floorId,
        },
      })
    },
    async doStepStart() {
      await this.fetchFloors()

      if (this.surveyInfo.floorId !== null) {
        this.$store.commit('updateSurveyFloorId', this.surveyInfo.floorId)
      } else if (this.floors.length === 1) {
        this.$store.commit('updateSurveyFloorId', this.floors[0].id)
      }

      if (this.allCompleted) {
        this.doStep('completed')
      } else if (
        this.surveyInfo.floorId !== null ||
        this.$store.state.surveyFloors.length === 1
      ) {
        this.doStep('sections')
      } else {
        this.doStep('floors')
      }
    },
    async doStep(step) {
      const lastStep = this.step

      this.step = step

      switch (step) {
        case 'start':
          await this.init()
          break
        case 'floors':
          // refresh floors when back step
          if (lastStep === 'sections') {
            await this.fetchFloors()

            if (this.allCompleted) {
              this.doStep('completed')

              return
            }
          }
          break
        case 'sections':
          await this.fetchSurveySections()
          break
        default:
          break
      }

      this.$router.push({
        path: '/onboarding-survey',
        query: {
          ...this.$route.query,
          step,
        },
      })
    },
    goToHome() {
      window.location.href = '/'
    },
  },
}
